import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
// import { ColumnChangeBO, EDI271BO, generate270, GetviewBO, reutrn270 } from  '../../models/eligibility270.model'; 
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SearchSettingsModel, ToolbarItems, FilterSettingsModel, IFilter, GridComponent, PageSettingsModel, DataStateChangeEventArgs, QueryCellInfoEventArgs, TextWrapSettingsModel, GridModule, ColumnChooserService, PageService, FilterService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
// import { columnWidth } from '../../models/icd10.model';
import { takeUntil } from 'rxjs/operators';
// import { CommonApiService } from '@services/commonapiservice';
// import { Get271Fileservice } from '@services/eligibility271.service';
// import { eligibility270Service } from '@services/eligibility270.service';
import { Vieweligibility271Component } from '../vieweligibility271/vieweligibility271.component';
import { CommonModule } from '@angular/common';
// import { DropdownComponent } from 'src/app/dropdown/dropdown.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { eligibility270Service } from 'src/app/service/eligibility270.service';
import { Get271Fileservice } from 'src/app/service/eligibility271.service';
import { ColumnChangeBO, EDI271BO, generate270, Getview270BO,  reutrn270 } from '../eligibility-logs/eligibility-logs-model';
import { columnWidth } from '../employee/employee.model';
import { DropdownComponent } from 'src/app/dropdown/dropdown.component';
import { CommonApiService } from 'src/app/service/commonapiservice';
import { Getview271BO, Getview271ListBO } from './eligibility270.model';
import { jsPDF } from 'jspdf';

@Component({
  selector: 'app-eligibility270',
  templateUrl: './eligibility270.component.html',
  styleUrls: ['./eligibility270.component.scss'],
 
})
export class Eligibility270Component implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('pdflist') pdflist;
  @ViewChild('pdf271list') pdf271list;
  @ViewChild('pdfIframe271') pdfIframe271: ElementRef<HTMLIFrameElement>;
  // Raw data URL from API (used for download and sanitization)
  pdfsrc: string = "";
  // Sanitized URL for iframe src binding (avoids Angular NG0904)
  safePdfSrc: SafeResourceUrl | null = null;
  private _271ObjectUrl: string | null = null;
  _271id: any = "";
  @ViewChild('gridview270') public gridview270: GridComponent;
  @ViewChild('gridview271') public gridview271: GridComponent;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ColumnArray_270: ColumnChangeBO[]
  initialPage: PageSettingsModel;
  initialPage1: PageSettingsModel;
  today: Date = new Date();
  edi271: EDI271BO = new EDI271BO();
  groupList: any = [];
  payorList: any = [];
  view271client: boolean = false;
  onDOCFileChangedErr: string = ""
  clearingHouseList: any = [];
  filepath: string = "";
  ColumnArrayImportList: any[];
  id: number = 0;
  companyList: any;
  public formatOptions: object;
  getview270: Getview270BO = new Getview270BO();
  getview271: Getview271ListBO = new Getview271ListBO();
  selectedFileName: string = ""
  generate270: generate270 = new generate270;
  created270: reutrn270 = new reutrn270;
  view270: boolean = false;
  viewFiles: boolean = false;
  viewFiles271: boolean = false;
  arraycol: any = [];
  List271Data: any = [];
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  filterOptions: FilterSettingsModel;
  filter: IFilter;
  public filterSettings: object;
  public data270: Observable<DataStateChangeEventArgs>;
  public data271: Observable<DataStateChangeEventArgs>;
  @ViewChild('grid271') public grid271: GridComponent;
  @ViewChild('gridview270') public grid270: GridComponent;
  fileToUpload: any = "";
  ColumnArray: columnWidth[];
  edi271tobedeleted: number = 0;
  dataviewList270: any = [];
  isinprogressfile:boolean=false;
  public wrapSettings: TextWrapSettingsModel;
  private _271Blob: Blob | null = null;
  constructor(
    public CommonAPI: CommonApiService,
    public global: GlobalComponent,
    public httpService: eligibility270Service,
    @Inject(Get271Fileservice) public gethttp271: Get271Fileservice,
    public toastrService: ToastrService,
    public http: HttpClient,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    this.global.agencyList();
    this.data270 = this.httpService;
    this.data271 = this.gethttp271;
  }

  private inferMimeFromBase64(base64: string): 'application/pdf' | 'text/html' {
    try {
      // Decode only a small prefix to detect content
      const sample = atob(base64.substring(0, 256));
      if (sample.startsWith('%PDF-')) return 'application/pdf';
      const trimmed = sample.trimStart();
      if (trimmed.startsWith('<!DOCTYPE') || trimmed.startsWith('<html') || trimmed.startsWith('<HTML')) {
        return 'text/html';
      }
    } catch {
      // ignore
    }
    // Default to PDF (historical behavior)
    return 'application/pdf';
  }

  private normalizeToDataUrl(input: any): string {
    const value = (typeof input === 'string') ? input : '';
    if (!value) return '';

    // Already a data URL
    if (value.startsWith('data:')) {
      const commaIndex = value.indexOf(',');
      if (commaIndex === -1) return value;
      const meta = value.substring(5, commaIndex); // after 'data:'
      const payload = value.substring(commaIndex + 1);
      // If meta says pdf but payload is actually HTML, fix mime
      if (meta.includes('base64')) {
        const mime = this.inferMimeFromBase64(payload);
        return `data:${mime};base64,${payload}`;
      }
      return value;
    }

    // Raw base64 (no header)
    const mime = this.inferMimeFromBase64(value);
    return `data:${mime};base64,${value}`;
  }

  private decodeBase64ToUtf8(base64: string): string {
    try {
      const binary = atob(base64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return new TextDecoder('utf-8').decode(bytes);
    } catch {
      return '';
    }
  }

  // Clean HTML content: remove pipe symbols from values and enhance styling
  private cleanHtmlContent(html: string): string {
    if (!html) return '';
    
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      
      // Remove pipe symbols from all text nodes
      const walker = doc.createTreeWalker(
        doc.body,
        NodeFilter.SHOW_TEXT,
        null
      );
      
      let node;
      while (node = walker.nextNode()) {
        if (node.textContent) {
          node.textContent = node.textContent.replace(/\|/g, '').trim();
        }
      }
      
      // Add enhanced styling
      const head = doc.querySelector('head') || doc.createElement('head');
      if (!doc.querySelector('head')) doc.insertBefore(head, doc.firstChild);
      
      const extraStyle = doc.createElement('style');
      extraStyle.textContent = `
        body { font-family: Arial, sans-serif; font-size: 12px; padding: 15px; line-height: 1.6; }
        h2 { color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 5px; margin-top: 20px; }
        h3 { color: #27ae60; margin-top: 15px; }
        .row { border-bottom: 1px solid #eee; padding: 8px 0; }
        .col-lg-3 { font-weight: bold; color: #555; width: 30%; display: inline-block; }
        .col-lg-9 { color: #333; width: 70%; display: inline-block; }
      `;
      head.appendChild(extraStyle);
      
      return doc.documentElement.outerHTML;
    } catch (e) {
      console.error('Error cleaning HTML:', e);
      return html.replace(/\|/g, '');
    }
  }

  private htmlToPlainText(html: string): string {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      // Remove head content that can include CSS text in some edge cases
      doc.querySelectorAll('style,script,noscript,head,meta,link,title').forEach(n => n.remove());
      const body = doc.body;
      const text = body ? ((body as any).innerText || body.textContent || '') : '';
      return (text || '').trim();
    } catch {
      return (html || '').trim();
    }
  }

  private htmlToPlainTextFast(html: string): string {
    // Faster (but less accurate) fallback for very large HTML.
    try {
      return (html || '')
        .replace(/<script[\s\S]*?<\/script>/gi, '')
        .replace(/<style[\s\S]*?<\/style>/gi, '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/?p\b[^>]*>/gi, '\n')
        .replace(/<\/?div\b[^>]*>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    } catch {
      return (html || '').trim();
    }
  }

  private extract271TextFromHtml(html: string): string {
    if (!html) return '';

    // Prefer extracting from <pre>/<code> blocks (common for EDI dumps)
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const candidates = Array.from(doc.querySelectorAll('pre,code,textarea')) as HTMLElement[];
      for (const el of candidates) {
        const t = (el.innerText || el.textContent || '').trim();
        if (/\bISA\*/.test(t)) return t;
      }
    } catch {
      // ignore
    }

    // Fallback: try to find an ISA segment in the raw HTML/text
    const raw = html;
    const isaIdx = raw.indexOf('ISA*');
    if (isaIdx >= 0) {
      return raw.substring(isaIdx).trim();
    }

    // Last resort: plain text extraction (with CSS/head removed)
    const plain = this.htmlToPlainText(html);
    const plainIsaIdx = plain.indexOf('ISA*');
    if (plainIsaIdx >= 0) {
      return plain.substring(plainIsaIdx).trim();
    }
    return plain;
  }
  ngOnInit(): void {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0) {
      return;
    }
    this.wrapSettings = { wrapMode: 'Content' };
    this.getGroupList();
    this.getClearingHouseList();
    this.toolbar = ['ColumnChooser'];
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.initialPage1 = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  }
  Refresh() {
    this.getview271.orderColumn = "id";
    this.getview271.field = "fileName";
    this.getview271.currentpageno = 1
    this.getview271.value = "";
    this.getview271.type = "string";
    this.selectedFileName = "";
    //this.gridview271.pageSettings.currentPage = 1;
    this.view271filedata();
    if (this.gridview271 && this.gridview271.filterSettings && this.gridview271.filterModule) {
      this.gridview271.clearFiltering();
    }
    if (this.gridview271 && this.gridview271.sortSettings && this.gridview271.sortModule) {
      this.gridview271.clearSorting();
    }
  }
  Refresh270() {
    this.getview270.type = "string";
    this.getview270.field = "FileName";
    this.getview270.operator = "startswith";
    this.getview270.value = "";
    this.getview270.orderColumn = "FileName";
    this.getview270.orderType = "asc";
    this.getview270.currentpageno = 1;
    this.gridview270.pageSettings.currentPage = 1;
    this.view270filedata();
    if (this.gridview270 && this.gridview270.filterSettings && this.gridview270.filterModule) {
      this.gridview270.clearFiltering();
    }
    if (this.gridview270 && this.gridview270.sortSettings && this.gridview270.sortModule) {
      this.gridview270.clearSorting();
    }
  }
  ////////////////////////////// Show Column Chooser /////////////////////////////////////
  show() {
    this.grid271.columnChooserModule.openColumnChooser(200, 50);
  }
  onDOCFileChanged() {
    if(this.isinprogressfile){
      this.toastrService.error("File is InProgress!");
      return;
    }
    this.selectedFileName = this.fileToUpload.name;
    let body = new FormData();
    body.append('Filepath', this.fileToUpload);
    let url = "api/Claims/Import271External?agency=" + this.global.globalAgencyId.toString();
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(body,url).pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.onDOCFileChangedErr = "";
        this.selectedFileName = '';
        this.toastrService.success(
          "File imported successfully!"
        ), 8000
        this.view271filedata();
        // if (data.length > 0) {
        //   this.onDOCFileChangedErr = "";
        //   this.onDOCFileChangedErr = data[0];
        //   if (this.onDOCFileChangedErr != "") {
        //     this.onDOCFileChangedErr = "Client(s) not Found: " + this.onDOCFileChangedErr;
        //   }
        //   if (this.onDOCFileChangedErr != "") {
        //     setTimeout(function () {
        //       this.onDOCFileChangedErr = "";
        //     }.bind(this), 8000);
        //   }
        // }
      },
(err: any) => {
  this.selectedFileName = '';
  this.onDOCFileChangedErr = '';

  let errorMessage = 'An error occurred while uploading the file.';

  console.log('Full Error Object:', err);
  console.log('err.error:', err.error);

  try {
    // The error comes as: Message: {"error":"271 file already exists for this agency"}
    if (typeof err === 'string') {
      let errorStr = err;
      
      // Extract JSON from "Message: {...}" pattern
      const jsonMatch = errorStr.match(/Message:\s*(\{.*\})/);
      if (jsonMatch && jsonMatch[1]) {
        try {
          const parsed = JSON.parse(jsonMatch[1]);
          errorMessage = parsed.error || parsed.message || errorMessage;
          console.log('Extracted error from Message prefix:', errorMessage);
        } catch (e) {
          console.log('Could not parse JSON from Message prefix');
          errorMessage = errorStr;
        }
      } else {
        // If no "Message:" prefix, try parsing directly
        try {
          const parsed = JSON.parse(errorStr);
          errorMessage = parsed.error || parsed.message || errorMessage;
        } catch (e) {
          // Use raw string if can't parse
          errorMessage = errorStr;
        }
      }
    } 
    else if (err.error && typeof err.error === 'object') {
      errorMessage = err.error.error || err.error.message || JSON.stringify(err.error);
    }
  } catch (parseError) {
    console.log('Error parsing:', parseError);
  }

  console.log('Final error message to show:', errorMessage);
  
  // Show error in toaster
  this.toastrService.error(errorMessage, 'Upload Error');
  this.onDOCFileChangedErr = errorMessage;

  // Clear error message after 5 seconds
  setTimeout(() => {
    this.onDOCFileChangedErr = '';
  }, 5000);

  // Refresh the file list
  this.view271filedata();
}
    );
  }
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("Code", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
      if (ListCode == 'GROUP') {
        this.groupList = data;
        this.groupList.forEach(element => {
          element.Key = element.Key.toString();
        })
        this.generate270.groupId = this.groupList.filter(s => s.Value == "MA")[0].Key;
        if (this.generate270.groupId != "00000000-0000-0000-0000-000000000000") {
          this.getpayorList();
        }
      }
    })
  }
  getGroupList() {
    this.generate270.companyId = "00000000";
    this.generate270.payorId = "";
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
    this.CommonAPI.getDropDownList('PAYER',params, url, "LovDropDown").then((data: [{ id: string, Value: string }]) => {
      this.groupList = data;
      // this.groupList.forEach(element => {
      //   element.Key = element.Key
      // })
      this.generate270.groupId = this.groupList.filter(s => s.lovValue == "MA")[0].id;
      if (this.generate270.groupId != "00000000-0000-0000-0000-000000000000") {
        this.getpayorList();
      }
    })
  }
  getpayorList() {
    this.generate270.payorId = "00000000-0000-0000-0000-000000000000"
    this.generate270.clearingHouseId = "00000000-0000-0000-0000-000000000000"
    this.generate270.companyId = "00000000-0000-0000-0000-000000000000";
    let param = new URLSearchParams();
    let GroupId: string = (this.generate270.groupId != null && this.generate270.groupId != undefined) ? this.generate270.groupId : "00000000-0000-0000-0000-000000000000"
    param.append("GroupId", GroupId.toString());
    let url = "api/Payerservice/GetPayerDropdown?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.payorList = data;
      this.payorList?.forEach(element => {
        element.Key = element.Key.toString();
      })
      let val = this.payorList.filter(s => s.Value == "MA");
      this.generate270.payorId = this.payorList != null ? val.length != 0 ? val[0].Key : "00000000-0000-0000-0000-000000000000" : "00000000-0000-0000-0000-000000000000"
      if (this.generate270.payorId != "00000000-0000-0000-0000-000000000000") {
        this.getCompanyList();
      }
    })
  }
  getCompanyList() {
    this.generate270.companyId = "00000000-0000-0000-0000-000000000000";
    let myparams = new URLSearchParams();
    if (this.generate270.groupId == null || this.generate270.groupId == undefined || this.generate270.groupId == "00000000-0000-0000-0000-000000000000" ||
      this.generate270.payorId == null || this.generate270.payorId == undefined || this.generate270.payorId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    myparams.append("GroupId", this.generate270.groupId.toString())
    myparams.append("PayorId", this.generate270.payorId.toString())
    let url = "api/Payer/getGroupCompanyBatch?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.companyList = data;
    })
  }
  getClearingHouseList() {
    let myparams = new URLSearchParams();
    let url = "api/ClearingHouse/getCommonClearingHouselist?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
      this.clearingHouseList = data;
      this.clearingHouseList.forEach(element => {
        element.Key = element.Key;
      })
  },)
  }
  generate270file() {
    let myparams = {
      "clearinghouse": this.generate270.clearingHouseId.toString(),
      "payer": this.generate270.payorId.toString(),
      "company": this.generate270.companyId.toString()
    }
    let url = "api/Claims/Save270";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.created270 = data;
      document.getElementById("openModal1").click();
    },
    (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;        
      }
    );
  }
  openfile() {
    this.viewFiles = true;
  }
  openview270(id) {
    let myparams = new URLSearchParams();
    myparams.append("id", id)
    let url = "api/Claims/Get270Data?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.created270 = data;
      this.viewFiles = true;
    },
    (err: HttpErrorResponse) => {
        this.toastrService.error(err?.error)
      }
    );
  }
openview271(datas: any) {

  // ===== 1. Basic validations =====
  if (!datas?.id) {
    this.toastrService.error('Invalid data', 'Error');
    return;
  }

  if (datas?.importStatus?.trim().toUpperCase() === 'FAILED') {
    this.toastrService.error(
      'Unable to view failed import file. Please check the file and try again.',
      'Import Failed'
    );
    return;
  }

  // ===== 2. Cleanup old preview =====
  if (this._271ObjectUrl) {
    URL.revokeObjectURL(this._271ObjectUrl);
    this._271ObjectUrl = null;
  }
  this._271Blob = null;

  this.safePdfSrc = null;
  this.cdr.detectChanges();

  // ===== 3. Prepare API params =====
  const myparams = new URLSearchParams();
  myparams.append('id', datas.id.toString());

  // ===== 4. API call (PDF as BLOB) =====
  this.CommonAPI
    .GetFunctionwithResponseTypeBlob(
      myparams,
      'api/Claims/Get271Details?'
    )
    .subscribe({
      next: (blob: Blob) => {
        // ===== 5. Validate blob =====
        if (!blob || blob.size === 0) {
          this.toastrService.error('Received empty PDF', 'Error');
          return;
        }

        if (blob.type !== 'application/pdf') {
          this.toastrService.error('Invalid file type received', 'Error');
          return;
        }

        // ===== 6. Store blob for download =====
        this._271Blob = blob;
        this.pdfsrc = URL.createObjectURL(blob);

        // ===== 7. Create Object URL for iframe =====
        this._271ObjectUrl = URL.createObjectURL(blob);

        // ===== 8. Bind to iframe =====
        this.safePdfSrc =
          this.sanitizer.bypassSecurityTrustResourceUrl(this._271ObjectUrl);

        this.cdr.detectChanges();

        // ===== 9. Open modal =====
        setTimeout(() => {
          document.getElementById('openModal3')?.click();
        }, 100);
      },

      error: (err) => {
        this.viewFiles271 = false;
        this.pdfsrc = '';
        this.safePdfSrc = null;
        this._271Blob = null;

        if (this._271ObjectUrl) {
          URL.revokeObjectURL(this._271ObjectUrl);
          this._271ObjectUrl = null;
        }

        this.toastrService.error(
          err?.error || 'Unable to load 271 PDF',
          'Error'
        );
      }
    });
}




  clear271Preview() {
    // Clean up blob URL resources
    if (this._271ObjectUrl) {
      URL.revokeObjectURL(this._271ObjectUrl);
      this._271ObjectUrl = null;
    }

    this._271Blob = null;
    this.safePdfSrc = null;
    this.pdfsrc = '';
    this.viewFiles271 = false;
    this.cdr.detectChanges();
  }
  view270filedata() {
    this.getview270.agencyID = parseInt(this.global.globalAgencyId)
    this.httpService.outputValues(this.getview270);
    let count = 0;
    this.httpService.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
      this.dataviewList270 = datas?.result;
      ++count;
      if (datas != null && datas != undefined && count == 1) {
        // this.getColumnwidthforEligibility270();
      }
      if (datas != null && datas?.result?.length > 15) {
        this.gridview270.height = '500';
      }
      else {
        this.gridview270.height = 'auto';
      }
    });
  }
  view271filedata() {
    this.gethttp271.outputValues(this.getview271);
    let count = 0;
    this.gethttp271.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
      this.List271Data = datas.result;
      ++count;
      this.isinprogressfile=datas.result[0]?.importStatus?.toUpperCase()=='INPROGRESS'
   
      if (datas != null && datas != undefined && count == 1) {
        //this.getColumnwidth();
      }
      if (datas != null && datas.result.length > 15) {
        this.grid271.height = '500';
      }
      else {
        this.grid271.height = 'auto';
      }
    })
  }
  public onActionCompleteview270(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridview270.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].BatchDetail.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].BatchDetail.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].BatchDetail.ShowColumns.length != count1 || this.arraycol[0].BatchDetail.HideColumns.length != count) {
            this.arraycol[0].BatchDetail.ShowColumns = showarr;
            this.arraycol[0].BatchDetail.HideColumns = hidearr;
            this.SaveColumnwidthViewbatch();
          }
        }
      }
    }
    this.getview270.currentpageno = this.gridview270.pagerModule.pagerObj.currentPage;
    this.getview270.pageitem = this.gridview270.pagerModule.pagerObj.pageSize;
    ;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getview270.type = args.columnType
    }
  }
  onActionCompleteview271(args) {
    this.getview271.currentpageno = this.grid271.pagerModule.pagerObj.currentPage;
    this.getview271.pageitem = this.grid271.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getview271.type = args.columnType
    }
  }
  ////////////////////////////// File uPload /////////////////////////////////////
  onFileChanged(event:any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileToUpload = input.files[0];
      this.selectedFileName = input.files[0].name;
    }
  
  }
  download270(data) {
    let myparams = new URLSearchParams();
    myparams.append("filepath", data);
    let url = "api/Claims/download270?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      window.open(data[0]);
    },
    (err: any) => {
        this.toastrService.error(err, 'Error'), 8000;        
      }
    );
  }
  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      this.pdflist.saveAs("270Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }
  kendopdfdownloadList271() {
    try {
      // ===== 1. Use stored blob if available =====
      if (this._271Blob) {
        const baseName = this._271id?.fileName 
          ? this._271id.fileName.split('.')[0] 
          : '271Record';

        const blobUrl = URL.createObjectURL(this._271Blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = `${baseName}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(blobUrl);
        return;
      }

      // ===== 2. Fallback: use pdfsrc if blob not available =====
      if (!this.pdfsrc || !this.pdfsrc.startsWith('data:')) {
        this.toastrService.error('No document to download', 'Error');
        return;
      }

      const commaIndex = this.pdfsrc.indexOf(',');
      if (commaIndex === -1) {
        this.toastrService.error('Invalid document format', 'Error');
        return;
      }

      const base64 = this.pdfsrc.substring(commaIndex + 1);
      const blob = this.b64toBlob(base64, 'application/pdf');
      const baseName = this._271id?.fileName 
        ? this._271id.fileName.split('.')[0] 
        : '271Record';

      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `${baseName}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (e) {
      this.toastrService.error('Download failed. Please try again.', 'Error');
      console.error('271 download error', e);
    }
  }
  public dataStateChange(state): void {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getview271.orderColumn = state.sorted[0].name;
        this.getview271.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.getview271.type == "number") {
        this.getview271.value = state.action.currentFilterObject.value.toString();
        this.getview271.field = state.action.currentFilterObject.field;
      }
      if (this.getview271.type == "date") {
        this.getview271.value = this.global.getDateTimeString(state.action.currentFilterObject.value)
        this.getview271.field = state.action.currentFilterObject.field;
      }
      else {
        this.getview271.value = state.action.currentFilterObject.value;
        this.getview271.field = state.action.currentFilterObject.field;
      }
      this.getview271.matchCase = state.action.currentFilterObject.matchCase;
      this.getview271.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getview271.field = "FileName";
        this.getview271.matchCase = false;
        this.getview271.operator = "contains";
        this.getview271.value = "";
        this.getview271.type = "string"
      }
    }
    this.view271filedata();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Import271.Pagesize != state.take) {
          this.arraycol[0].Import271.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
  }
  public dataStateChange270(state): void {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getview270.orderColumn = state.sorted[0].name;
        this.getview270.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (state.action.currentFilterObject.type== "number") {
        this.getview270.value = state.action.currentFilterObject.value.toString();
        this.getview270.field = state.action.currentFilterObject.field;
      }
      if (state.action.currentFilterObject.type == "date") {
        this.getview270.value = this.global.getDateTimeString(state.action.currentFilterObject.value)
        this.getview270.field = state.action.currentFilterObject.field;
      }
     
      else {
        this.getview270.value = state.action.currentFilterObject.value;
        this.getview270.field = state.action.currentFilterObject.field;
        this.getview270.type = state.action.currentFilterObject.type;

      }
      this.getview270.matchCase = state.action.currentFilterObject.matchCase;
      this.getview270.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.getview270.field = "fileName";
        this.getview270.matchCase = false;
        this.getview270.operator = "contains";
        this.getview270.value = "";
        this.getview270.type = "string"
      }
    }
    
    this.view270filedata();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Eligibility270.Pagesize != state.take) {
          this.arraycol[0].Eligibility270.Pagesize = state.take
          this.SaveColumnwidthforEligibility270();
        }
      }
    }
  }
  showColumn() {
    this.gridview270.columnChooserModule.openColumnChooser(200, 50);
  }
  SaveColumnwidthViewbatch() {
    this.arraycol[0].view270.Columns = this.ColumnArray_270;
    this.arraycol[0].view270.Pagesize = this.gridview270.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    });
  }
  make271false() {
    this.view271client = false;
  }
  ///====================Resize Import271 List===========================////
  onResizeSelected(args) {
    if (this.ColumnArrayImportList != null && this.ColumnArrayImportList != undefined) {
      const column = this.grid271.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArrayImportList.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArrayImportList = this.arraycol[0].Import271.Columns;
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    if (this.grid271 != undefined) {
      this.grid271.pageSettings.pageSize = this.arraycol[0].Import271.Pagesize;
    }
    this.ColumnArrayImportList.forEach(element => {
      if (element.column == 'Import Date') {
        const column = this.grid271?.getColumnByField('importedDate');
        this.grid271?.refreshHeader();
      }
      if (element.column == 'File Name') {
        const column = this.grid271?.getColumnByField('fileName');
        this.grid271?.refreshHeader();
      }
      if (element.column == 'Import Status') {
        const column1 = this.grid271?.getColumnByField('importStatus');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid271.refreshHeader();
      }
      if (element.column == 'Error') {
        const column1 = this.grid271?.getColumnByField('error');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid271.refreshHeader();
      }
      if (element.column == 'Action') {
        const column2 = this.grid271?.getColumnByUid('action');
        this.grid271?.refreshHeader();
      }
    });
  }
  SaveColumnwidth() {
    this.arraycol[0].Import271.Columns = this.ColumnArrayImportList;
    this.arraycol[0].Import271.Pagesize = this.grid271.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
  getColumnwidthforEligibility270() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Eligibility270.Columns;
    let showcol = this.arraycol[0].Eligibility270.ShowColumns;
    let hidecol = this.arraycol[0].Eligibility270.HideColumns
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.gridview270.pageSettings.pageSize = this.arraycol[0].Eligibility270.Pagesize;
    this.ColumnArray.forEach(element => {
      if (element.column == 'Company') {
        const column = this.gridview270.getColumnByField('companyName');
        column.width = element.width;
        this.gridview270.refreshHeader();
      }
      if (element.column == 'Clearing House') {
        const column1 = this.gridview270.getColumnByField('clearingHouseName');
        column1.width = element.width;
        this.gridview270.refreshHeader();
      }
      if (element.column == 'File Name') {
        const column1 = this.gridview270.getColumnByField('fileName');
        column1.width = element.width;
        this.gridview270.refreshHeader();
      }
      if (element.column == 'Generated Date') {
        const column1 = this.gridview270.getColumnByField('createDate');
        column1.width = element.width;
        this.gridview270.refreshHeader();
      }
      else if (element.column == 'Action') {
        const column2 = this.gridview270.getColumnByUid('action');
        column2.width = element.width;
        this.gridview270.refreshHeader();
      }
    });
  }
  onResizeEligibility270(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridview270.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidthforEligibility270();
    }
  }
  SaveColumnwidthforEligibility270() {
    this.arraycol[0].Eligibility270.Columns = this.ColumnArray;
    this.arraycol[0].Eligibility270.Pagesize = this.gridview270.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidthforEligibility270();
    });
  }
  selectEDI271toDelete(data) {
    this.edi271tobedeleted = data.id;
  }
  showSetting() {
    this.grid271.columnChooserModule.openColumnChooser(200, 50);
  }
  deleteEDI271() {
    let url="api/Claims/DeleteEDI271Import/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.edi271tobedeleted,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('delete271modalopen').click();
      this.toastrService.success('Deleted successfully!'), 8000;
      this.view271filedata();
    },   (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;        
      }
    }
    );
  }
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
